import React from "react";
import { AlertCircleIcon } from "lucide-react";
type FormFieldProps = {
  id: string;
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  error?: string;
  optional?: boolean;
  type?: "text" | "email" | "tel";
  autoComplete?: string;
  inputMode?: React.HTMLAttributes<HTMLInputElement>["inputMode"];
  multiline?: boolean;
  hint?: string;
};
export function FormField({
  id,
  label,
  value,
  onChange,
  error,
  optional = false,
  type = "text",
  autoComplete,
  inputMode,
  multiline = false,
  hint
}: FormFieldProps) {
  const errorId = `${id}-error`;
  const hintId = `${id}-hint`;
  const describedBy = [hint ? hintId : null, error ? errorId : null].filter(Boolean).join(" ") || undefined;
  const fieldClass = `mt-2 block w-full rounded-md border-2 bg-white px-4 text-ink placeholder:text-slate ${error ? "border-crimson" : "border-slate"}`;
  return <div data-id="element-85" data-mp="exm5meo8mweb">
      <label htmlFor={id} className="block text-label font-bold text-ink" data-id="element-86" data-mp="excgetb0ot9o">
        {label}
        {optional && <span className="font-normal text-slate" data-id="element-87" data-mp="zksgl7amf24w"> (optional)</span>}
      </label>
      {hint && <p id={hintId} className="mt-1 text-meta text-slate" data-id="element-88" data-mp="1ei1nj9ceqehq">
          {hint}
        </p>}
      {multiline ? <textarea id={id} name={id} rows={4} value={value} onChange={onChange} aria-invalid={error ? true : undefined} aria-describedby={describedBy} className={`${fieldClass} py-3`} data-id="element-89" data-mp="19ifbv4c896b1" /> : <input id={id} name={id} type={type} value={value} onChange={onChange} autoComplete={autoComplete} inputMode={inputMode} required={!optional} aria-required={!optional} aria-invalid={error ? true : undefined} aria-describedby={describedBy} className={`${fieldClass} min-h-[56px]`} data-id="element-90" data-mp="1x8jaexak6fv6" />}
      {error && <p id={errorId} className="mt-2 flex items-start gap-2 text-meta font-semibold text-crimson" data-id="element-91" data-mp="29c566dm023li">
          <AlertCircleIcon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0" data-id="element-92" data-mp="2eaoswg8f3jex" />
          {error}
        </p>}
    </div>;
}